"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectAddons = void 0;
const react_1 = __importDefault(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const configContext_1 = require("../../context/configContext");
require("./MultiSelect.scss");
const MultiSelectAddons = (props) => {
    const config = (0, configContext_1.useConfig)();
    const allAddonTypes = config
        .getAllAddonTypes({ includeHidden: true, includeMisc: true })
        .map((addonType) => ({ value: addonType, label: addonType }));
    const selectedAddonTypes = allAddonTypes.filter((addonType) => props.selectedAddonTypes.includes(addonType.value));
    const selectAllOption = {
        value: "-all-",
        label: "Alle",
    };
    return (react_1.default.createElement(react_select_1.default, { className: "multi-select", onChange: (selected, actionMeta) => {
            if (selected && Array.isArray(selected)) {
                if (selected.includes(selectAllOption)) {
                    // All are selected.
                    props.onSelectedAddonTypesChange(allAddonTypes.map((s) => s.value));
                }
                else {
                    props.onSelectedAddonTypesChange(selected.map((s) => s.value));
                }
            }
            else {
                props.onSelectedAddonTypesChange([]);
            }
        }, value: selectedAddonTypes, closeMenuOnSelect: false, isSearchable: true, isMulti: true, options: selectedAddonTypes.length < allAddonTypes.length
            ? [selectAllOption, ...allAddonTypes]
            : allAddonTypes }));
};
exports.MultiSelectAddons = MultiSelectAddons;
